import React, {useEffect} from "react";
import { Link } from 'gatsby'

import { useIntl } from "gatsby-plugin-intl";
import {StaticImage} from 'gatsby-plugin-image';

import Navigation from '../Navigation';
import Language from "../Language";

import '../../styles/global.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faTelegram,
        faLinkedin,
        faWhatsapp,
        faFacebook,
        faYoutube,
        faInstagram,
    } from '@fortawesome/free-brands-svg-icons';

const Layout = ({ children, isHome }) => {
  
  const intl = useIntl();

  const stylingName = (name) =>{  
    let finalClass = name;
    const rtl = intl.locale !== "fa" ? false : true ;
    if (rtl) {
      finalClass = `${name}RTL` ; 
    } 
    return finalClass; 
  }
  
  useEffect(()=>{
    const body = document.querySelector("body");
    const pTags = document.querySelectorAll("p");
    if(intl.locale === "hy"){
        body.classList.add("HyFont");
        [...pTags].forEach(item=>{
            item.classList.add("HyFont");
        })
    }else{
        body.classList.remove("HyFont");
        [...pTags].forEach(item=>{
            item.classList.remove("HyFont");
        })
    }
    makeHeaderSticky()
  },[intl.locale]);

  const makeHeaderSticky = ()=>{
    const header = document.getElementById("header");
    if (!isHome) header.classList.add("sticky");
    }

  return (
    <div className={stylingName("viewport")}>
        <div className="viewport-top">
            <header className={stylingName("site-head")} id="header">
                <div className={stylingName("container")}>
                    <div className="site-mast">
                        <div className="site-mast-left">
                            <Link to="/">
                                <StaticImage src='../../../static/img/White.jpg' className="site-logo" alt='Gritarres LOGO'/>
                            </Link>
                        </div>
                        <div className="site-mast-right">
                            <Language/>
                        </div>   
                    </div>
                    { isHome ?
                        <div className="site-banner">
                            <h1 className="site-banner-title">{intl.formatMessage({id: "Gritarres Law Firm"})}</h1>
                            <p className="site-banner-desc">{intl.formatMessage({id: "At his best, man is the noblest of all animals; separated from law and justice he is the worst."})}</p>
                            <i className="site-banner-desc">{intl.formatMessage({id: "Aristotle"})}</i>
                        </div> :
                        null
                    }
                    <nav className="site-nav">
                        <div className="site-nav-left">
                            <Navigation navClass="site-nav-item"/>
                        </div>
                        <div className="site-nav-social">
                        <a 
                            href='https://wa.me/98476003' 
                            className="site-nav-item"
                            target='_blank'
                            rel='noreferrer'
                            >
                                <FontAwesomeIcon
                                className="site-nav-icon"
                                icon={faWhatsapp}
                                alt="WhatsApp"
                                />
                        </a>
                        <a href='https://t.me/Gritarres' 
                            className="site-nav-item"
                            target='_blank'
                            rel='noreferrer'
                            >
                            <FontAwesomeIcon 
                                className="site-nav-icon" 
                                icon={faTelegram}
                                alt="Telegram" />
                        </a>
                        <a href='https://www.facebook.com/Gritarres/' 
                            className="site-nav-item" 
                            target='_blank'
                            rel='noreferrer'
                            >
                                <FontAwesomeIcon 
                                    className="site-nav-icon" 
                                    icon={faFacebook} 
                                    alt="Facebook"/>
                        </a>
                        <a href='https://www.instagram.com/gritarreslawfirm/' 
                            className="site-nav-item"
                            target='_blank'
                            rel='noreferrer'
                            >
                                <FontAwesomeIcon 
                                    className="site-nav-icon" 
                                    icon={faInstagram} 
                                    alt="Instagram"/>
                        </a>
                        <a href='https://www.linkedin.com/company/gritarres-professional-law-firm/' 
                            className="site-nav-item"
                            target='_blank'
                            rel='noreferrer'
                            >
                                <FontAwesomeIcon 
                                    className="site-nav-icon" 
                                    icon={faLinkedin}
                                    alt="LinkedIn"/>
                        </a>
                        <a 
                            href='https://www.youtube.com/@Gritarres' 
                            className="site-nav-item"
                            target='_blank'
                            rel='noreferrer'
                            >
                                <FontAwesomeIcon
                                className="site-nav-icon"
                                icon={faYoutube}
                                alt="YouTube" />
                        </a>              
                    </div>
                    </nav>
                    <div className="site-nav-social-fullRow">
                        <a 
                            href='https://wa.me/98476003' 
                            className="site-nav-item"
                            target='_blank'
                            rel='noreferrer'
                            >
                                <FontAwesomeIcon
                                className="site-nav-icon"
                                icon={faWhatsapp}
                                alt="WhatsApp"
                                />
                        </a>
                        <a href='https://t.me/Gritarres' 
                            className="site-nav-item"
                            target='_blank'
                            rel='noreferrer'
                            >
                            <FontAwesomeIcon 
                                className="site-nav-icon" 
                                icon={faTelegram}
                                alt="Telegram" />
                        </a>
                        <a href='https://www.facebook.com/Gritarres/' 
                            className="site-nav-item" 
                            target='_blank'
                            rel='noreferrer'
                            >
                                <FontAwesomeIcon 
                                    className="site-nav-icon" 
                                    icon={faFacebook} 
                                    alt="Facebook"/>
                        </a>
                        <a href='https://www.instagram.com/gritarreslawfirm/' 
                            className="site-nav-item"
                            target='_blank'
                            rel='noreferrer'
                            >
                                <FontAwesomeIcon 
                                    className="site-nav-icon" 
                                    icon={faInstagram} 
                                    alt="Instagram"/>
                        </a>
                        <a href='https://www.linkedin.com/company/gritarres-professional-law-firm/' 
                            className="site-nav-item"
                            target='_blank'
                            rel='noreferrer'
                            >
                                <FontAwesomeIcon 
                                    className="site-nav-icon" 
                                    icon={faLinkedin}
                                    alt="LinkedIn"/>
                        </a>
                        <a 
                            href='https://www.youtube.com/@Gritarres' 
                            className="site-nav-item"
                            target='_blank'
                            rel='noreferrer'
                            >
                                <FontAwesomeIcon
                                className="site-nav-icon"
                                icon={faYoutube}
                                alt="YouTube" />
                        </a>              
                    </div>
                </div>
            </header>

            <main className="site-main">
                <html lang={intl.locale} />
                <meta charSet="utf-8" />
                {/* All the main content gets inserted here, index.js, post.js */}
                {children}
            </main>
        </div>

        <div className="viewport-bottom">
            {/* The footer at the very bottom of the screen */}
            <footer className="site-foot">
                <div className="site-foot-nav container">
                    <div className="site-foot-nav-left">
                        <Link to="/">Gritarres</Link> © 2024 &mdash; Developed by: <a className="site-foot-nav-item" href="https://t.me/Alexander_shah" target="_blank" rel="noopener noreferrer">Shahab</a>
                    </div>
                    <div className="site-foot-nav-right">
                        <Navigation navClass="site-foot-nav-item" />
                    </div>
                </div>
            </footer>

        </div>
    </div>
  )
}

export default Layout
